import { createTheme } from '@material-ui/core/styles';

// @see: https://v4.mui.com/customization/default-theme/
const theme = createTheme({
  palette: {
    primary: {
      main: '#0052CC',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});
export default theme;
